<div class="confirm-auth">
    <div class="confirm-auth__wrapper">
        <h2 class="confirm-auth__title" [translate]="'auth.confirmAuth.title'"></h2>

        @if (data?.status !== httpStatus.RATE_LIMIT_TWO_FACTOR_ATTEMPTS && data?.status !==
        httpStatus.TWO_FACTOR_EMAIL_COOLDOWN && !timerInterval && data?.status !== httpStatus.RATE_LIMIT_LOGIN_ATTEMPTS)
        {
        <div class="confirm-auth__message">
            <span [translate]="'auth.confirmAuth.message'" [translateParams]="{email: email}"></span>
        </div>
        }

        @if (data?.status === httpStatus.RATE_LIMIT_TWO_FACTOR_ATTEMPTS && timerInterval || data?.status ===
        httpStatus.TWO_FACTOR_EMAIL_COOLDOWN && timerInterval || data?.status === httpStatus.RATE_LIMIT_LOGIN_ATTEMPTS
        && timerInterval) {
        <div class="confirm-auth__error"
            [class.confirm-auth__error--two]="data?.status === httpStatus.TWO_FACTOR_EMAIL_COOLDOWN && timerInterval">
            <div class="confirm-auth__error-icon">
                <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.125 1.25C10.3255 1.25 10.5242 1.30304 10.7012 1.40527C10.834 1.48206 10.9516 1.58525 11.0479 1.70898L11.1367 1.83887L19.3359 15.8848H19.3369C19.4428 16.073 19.4994 16.2879 19.5 16.5078C19.5006 16.7277 19.4448 16.9429 19.3398 17.1318C19.235 17.3206 19.0853 17.4755 18.9072 17.583C18.7292 17.6905 18.5279 17.7477 18.3242 17.75H1.92578C1.72208 17.7477 1.52076 17.6905 1.34277 17.583C1.16475 17.4755 1.015 17.3206 0.910156 17.1318C0.805226 16.9429 0.7494 16.7277 0.75 16.5078C0.750623 16.2879 0.80716 16.073 0.913086 15.8848L9.11328 1.83887C9.2212 1.65632 9.37188 1.50758 9.54883 1.40527C9.7258 1.30304 9.92448 1.25 10.125 1.25Z"
                        stroke="#F25D5D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.125 6.56848V10.5458" stroke="#F25D5D" stroke-width="1.7" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M10.125 14V14.4972" stroke="#F25D5D" stroke-width="1.7" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <span [translate]="'auth.confirmAuth.error'"></span>
            </div>

            <div class="confirm-auth__error-text">
                {{(data?.status === httpStatus.TWO_FACTOR_EMAIL_COOLDOWN ? 'auth.confirmAuth.errorTimerTwo' :
                (data?.status === httpStatus.RATE_LIMIT_LOGIN_ATTEMPTS ? 'auth.confirmAuth.errorTimerLogin' :
                'auth.confirmAuth.errorTimer')) | translate}} <span>{{getFormattedTime()}}
                    {{'auth.confirmAuth.errorTimerMin' | translate}}</span>
            </div>
        </div>
        }

        @if (data?.status !== httpStatus.RATE_LIMIT_LOGIN_ATTEMPTS) {

        <div class="confirm-auth__field"
            [class.confirm-auth__field--error]="data?.status === httpStatus.TWO_FACTOR_AUTHENTICATION_TOKEN_NOT_VALID">
            <label class="confirm-auth__label" [translate]="'auth.confirmAuth.code'"></label>
            <input minlength="6" maxlength="6" type="text" class="confirm-auth__input"
                [disabled]="(data?.status === httpStatus.RATE_LIMIT_TWO_FACTOR_ATTEMPTS && timerInterval)"
                [placeholder]="'profile.authenticationPopup.inputPlaceholder' | translate" name="confirmationCode"
                required [(ngModel)]="code" appTrimInput>

            @if (data?.status === httpStatus.TWO_FACTOR_AUTHENTICATION_TOKEN_NOT_VALID) {
            <div class="confirm-auth__field-error">
                <span [translate]="'auth.confirmAuth.errorCode'"></span>
            </div>
            }
        </div>

        @let isDisabled = !code || code.length !== 6 || (data?.status === httpStatus.RATE_LIMIT_TWO_FACTOR_ATTEMPTS &&
        timerInterval) || isStartResendTimer;

        <div class="confirm-auth__checkbox">
            <app-checkbox (changeEvent)="isRemember = !isRemember" [title]="'auth.confirmAuth.remember'"
                [isDisabled]="!code || (data?.status === httpStatus.RATE_LIMIT_TWO_FACTOR_ATTEMPTS && timerInterval)"></app-checkbox>
        </div>

        <div class="confirm-auth__btns">
            <button (click)="confirmCode()" class="btn" [disabled]="isDisabled" [translate]="'btns.confirm'">
            </button>

            <div (click)="resendEmailCode()" class="confirm-auth__resend"
                [class.confirm-auth__resend--disabled]="resendTimer > 0 || (data?.status === httpStatus.RATE_LIMIT_TWO_FACTOR_ATTEMPTS && timerInterval)">
                <svg-icon [src]="resentCodeIcon"></svg-icon>

                <span [translate]="isStartResendTimer ? 'auth.confirmAuth.resendTimer' : 'auth.confirmAuth.resend'"
                    [translateParams]="{time: resendTimer}"></span>
            </div>
        </div>
        }
    </div>